import api from "@/lib/api";

export const STATUS_COLOR = {
  EXALTED: "#D4AF37",
  NORMAL: "#5B8C6E",
  AFFLICTED: "#C98A3C",
  WEAK: "#C98A3C",
  MALEFIC: "#C0552F",
  INACTIVE: "#7A6BB0",
  DEPLETED: "#5A6B60",
};

export const statusColor = (s) => STATUS_COLOR[String(s || "").toUpperCase()] || "#6E7B72";

export const scoreColor = (v) => (v >= 70 ? "#D4AF37" : v >= 50 ? "#5B8C6E" : v >= 20 ? "#C98A3C" : "#C0552F");

export async function downloadAstroPdf(scanId, type, label) {
  const res = await api.get(`/astro/report/${scanId}/${type}/pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `voicematrix-${type}-report.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}
